/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Push_Native_DeniedInputs */

const th_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`การแจ้งเตือนถูกปิดกั้นสำหรับแอปนี้ กรุณาอนุญาตในการตั้งค่าระบบ`)
};

const en_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications are blocked for this app. Allow them in your system settings.`)
};

const ja_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このアプリの通知はブロックされています。システム設定で許可してください。`)
};

const zh_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此应用的通知已被阻止。请在系统设置中允许。`)
};

const es_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las notificaciones están bloqueadas para esta aplicación. Permítelas en los ajustes del sistema.`)
};

const pt_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As notificações estão bloqueadas para este aplicativo. Permita-as nas configurações do sistema.`)
};

const id_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifikasi diblokir untuk aplikasi ini. Izinkan di Pengaturan Sistem.`)
};

const fr_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les notifications sont bloquées pour cette application. Autorisez-les dans les réglages du système.`)
};

const tl_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naka-block ang mga notipikasyon para sa app na ito. Payagan ang mga ito sa System Settings.`)
};

const vi_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thông báo bị chặn với ứng dụng này. Hãy cho phép trong Cài đặt hệ thống.`)
};

const ko_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 앱의 알림이 차단되어 있습니다. 시스템 설정에서 허용하세요.`)
};

const de_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen sind für diese App blockiert. Erlaube sie in den Systemeinstellungen.`)
};

const ru_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уведомления для этого приложения заблокированы. Разрешите их в системных настройках.`)
};

const tr_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu uygulama için bildirimler engellendi. Sistem Ayarları'ndan izin verin.`)
};

const it_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le notifiche sono bloccate per questa app. Consentile in Impostazioni di Sistema.`)
};

const pl_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Powiadomienia dla tej aplikacji są zablokowane. Zezwól na nie w Ustawieniach systemowych.`)
};

const uk_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сповіщення для цього застосунку заблоковано. Дозвольте їх у системних налаштуваннях.`)
};

const hi_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस ऐप के लिए सूचनाएँ अवरुद्ध हैं। सिस्टम सेटिंग्स में अनुमति दें।`)
};

const ar_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإشعارات محظورة لهذا التطبيق. اسمح بها من إعدادات النظام.`)
};

const ms_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemberitahuan disekat untuk aplikasi ini. Benarkannya dalam Tetapan Sistem.`)
};

const bn_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এই অ্যাপের বিজ্ঞপ্তি আটকানো আছে। সিস্টেম সেটিংসে অনুমতি দিন।`)
};

const zh_tw2_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個應用程式的通知已被封鎖。請在系統設定中允許。`)
};

const zh_hk2_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這個應用程式的通知已被封鎖。請在系統設定中允許。`)
};

const ur_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اس ایپ کی اطلاعات روکی گئی ہیں۔ سسٹم کی ترتیبات میں اجازت دیں۔`)
};

const fa_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اعلان‌های این برنامه مسدود شده‌اند. در تنظیمات سامانه اجازه دهید.`)
};

const sw_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arifa za programu hii zimezuiwa. Ziruhusu kwenye Mipangilio ya Mfumo.`)
};

const nl_push_native_denied = /** @type {(inputs: Push_Native_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen zijn geblokkeerd voor deze app. Sta ze toe in Systeeminstellingen.`)
};

/**
* | output |
* | --- |
* | "Notifications are blocked for this app. Allow them in your system settings." |
*
* @param {Push_Native_DeniedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const push_native_denied = /** @type {((inputs?: Push_Native_DeniedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Push_Native_DeniedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_push_native_denied(inputs)
	if (locale === "ja") return ja_push_native_denied(inputs)
	if (locale === "zh") return zh_push_native_denied(inputs)
	if (locale === "es") return es_push_native_denied(inputs)
	if (locale === "pt") return pt_push_native_denied(inputs)
	if (locale === "id") return id_push_native_denied(inputs)
	if (locale === "fr") return fr_push_native_denied(inputs)
	if (locale === "tl") return tl_push_native_denied(inputs)
	if (locale === "vi") return vi_push_native_denied(inputs)
	if (locale === "ko") return ko_push_native_denied(inputs)
	if (locale === "de") return de_push_native_denied(inputs)
	if (locale === "ru") return ru_push_native_denied(inputs)
	if (locale === "tr") return tr_push_native_denied(inputs)
	if (locale === "it") return it_push_native_denied(inputs)
	if (locale === "pl") return pl_push_native_denied(inputs)
	if (locale === "uk") return uk_push_native_denied(inputs)
	if (locale === "hi") return hi_push_native_denied(inputs)
	if (locale === "ar") return ar_push_native_denied(inputs)
	if (locale === "ms") return ms_push_native_denied(inputs)
	if (locale === "bn") return bn_push_native_denied(inputs)
	if (locale === "zh-TW") return zh_tw2_push_native_denied(inputs)
	if (locale === "zh-HK") return zh_hk2_push_native_denied(inputs)
	if (locale === "ur") return ur_push_native_denied(inputs)
	if (locale === "fa") return fa_push_native_denied(inputs)
	if (locale === "sw") return sw_push_native_denied(inputs)
	if (locale === "nl") return nl_push_native_denied(inputs)
	return en_push_native_denied(inputs)
});